<script lang="ts">
	import { Button, Container, Label, Text } from '@Shelly/shelly-design-system/index';
	import {
		conversionFactors,
		convertDistUnits,
		DISTANCE_BASE_SIZE,
	} from 'src/helpers/distance_helper';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';

	export let device;
	export let deviceData;
	export let distanceUnit;

	const dispatch = createEventDispatcher();

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: liveDistance =
		deviceData.measureFromBase && status?.['distance:0']?.value > 0
			? status?.['distance:0']?.value + DISTANCE_BASE_SIZE
			: status?.['distance:0']?.value;
	$: factor = conversionFactors[distanceUnit] || 1;
</script>

<Container type="modalContainer" padding="xs" class="mb-s">
	<div class="d-flex justify-content-between align-items-center">
		<div>
			<Text styleType="body-small" class="mb-xs text-600">
				{$format('label_live_distance', { default: 'Live distance' })}
			</Text>
			<Label
				type="color-0"
				icon="fas fa-line-height"
				value={`${distanceUnit === 'in' ? (+liveDistance / factor).toFixed(2) : liveDistance} ${convertDistUnits(distanceUnit)}`}
				size="m"
			/>
		</div>
		<Button size="m" variant="secondary" on:click={() => dispatch('click', { liveDistance })}>
			{deviceData.modeType === 'occupancy'
				? $format('button_capture_baseline', {
						default: 'Capture baseline',
					})
				: $format('button_capture_height', { default: 'Capture height' })}
		</Button>
	</div>
</Container>
